import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavHourglassIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 14.0088,
		cy: 14.0088,
		r: 12.5088,
		fill: "#E2EDFF",
		stroke: "#354C8F"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.7092 7.22852H10.3452C9.93726 7.22852 9.5811 7.52606 9.58204 7.934C9.58756 10.328 11.5197 12.3512 12.6541 13.1793C12.7183 13.2262 12.7776 13.2793 12.8159 13.3489C12.9103 13.5205 13.0278 13.8447 13.0278 14.2865C13.0278 14.84 12.7049 15.163 12.5434 15.2552C10.4343 16.8141 9.75904 18.7973 9.64039 20.0486C9.60043 20.47 9.95753 20.7909 10.3808 20.7909H17.5947C18.0533 20.7909 18.431 20.417 18.3671 19.9629C18.0246 17.5279 16.2465 15.8372 15.3112 15.2552C15.1959 15.163 14.9652 14.84 14.9652 14.2865C14.9652 13.7329 15.1959 13.3639 15.3112 13.2485C17.6828 11.4242 18.3698 9.25547 18.4479 7.94191C18.4723 7.53129 18.1205 7.22852 17.7092 7.22852Z",
		fill: "#354C8F"
	})]
});
export default SvgNavHourglassIcon;
